var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(this.$route.query.biddingType==1)?_c('InquiryAnnouncement'):_c('TenderAnnouncement')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }